
<script setup lang="ts">
const isVisible = ref(false)

// Nuxt의 전역 상태 가져오기 (Plugin에서 이미 설정됨)
const isInAppBrowser = useState('isInAppBrowser', () => false)

const copyToClipboard = (val: string) => {
  const textarea = document.createElement("textarea");
  document.body.appendChild(textarea);
  textarea.value = val;
  textarea.select();
  document.execCommand('copy');
  document.body.removeChild(textarea);
};

const inappBrowserOut = () => {
  const currentUrl = window.location.href;
  copyToClipboard(currentUrl);

  alert('URL주소가 복사되었습니다.\n\nSafari가 열리면 주소창을 길게 터치한 뒤, "붙여놓기 및 이동"를 누르면 정상적으로 이용하실 수 있습니다.');
  window.location.href = 'x-safari-https://' + currentUrl.replace(/https?:\/\//i, '');
};

onMounted(() => {
  // Plugin에서 이미 감지했으므로 리다이렉트만 처리
  const userAgent = navigator.userAgent.toLowerCase();
  const targetUrl = window.location.href;

  // console.log('🔍 InAppBrowserRedirect - 인앱 브라우저:', isInAppBrowser.value)

  if (userAgent.match(/kakaotalk/i)) {
    window.location.href = `kakaotalk://web/openExternal?url=${encodeURIComponent(targetUrl)}`;
    // 카카오의 경우 인앱 탈출 후, 인앱에서 실행된 브라우저 닫기
    setTimeout(() => {
      if(userAgent.match(/iphone|ipad|ipod/i)){
        location.href = 'kakaoweb://closeBrowser';
      } else{
        location.href = 'kakaotalk://inappbrowser/close';
      }
    }, 1000)
  } else if (userAgent.match(/line/i)) {
    const separator = targetUrl.includes('?') ? '&' : '?';
    window.location.href = `${targetUrl}${separator}openExternalBrowser=1`;
  } else if (userAgent.match(/inapp|naver|snapchat|wirtschaftswoche|thunderbird|instagram|everytimeapp|whatsApp|electron|wadiz|aliapp|zumapp|iphone(.*)whale|android(.*)whale|kakaostory|band|twitter|DaumApps|DaumDevice\/mobile|FB_IAB|FB4A|FBAN|FBIOS|FBSS|SamsungBrowser\/[^1]/i)) {
    if (userAgent.match(/iphone|ipad|ipod/i)) {
      // iOS 인앱 브라우저: 안내 화면 표시
      isVisible.value = true
      /*document.body.innerHTML = `
        <div class="inapp-redirect-container">
          <h2>인앱브라우저 호환문제로 인해<br />Safari로 접속해야합니다.</h2>
          <div class="redirect-message">
            <p>아래 버튼을 눌러 Safari를 실행해주세요</p>
            <p>Safari가 열리면, 주소창을 길게 터치한 뒤,</p>
            <p>'붙여놓기 및 이동'을 누르면</p>
            <p>정상적으로 이용할 수 있습니다.</p>
            <button
              @click="inappBrowserOut"
              class="safari-button"
            >
              Safari로 열기
            </button>
          </div>
        </div>
      `;*/
    } else {
      // Android 인앱 브라우저: 즉시 Chrome으로 리다이렉트
      isVisible.value = false
      window.location.href = `intent://${targetUrl.replace(/https?:\/\//i, '')}#Intent;scheme=http;package=com.android.chrome;end`;
    }
  }
  // else 블록 제거 - 일반 브라우저는 아무것도 안 함 (Plugin에서 이미 false로 설정됨)
});
</script>

<template>
  <div v-if="isVisible">
    <div class="inapp-redirect-container">
      <h2>인앱브라우저 호환문제로 인해<br />Safari로 접속해야합니다.</h2>
      <div class="redirect-message">
        <p>아래 버튼을 눌러 Safari를 실행해주세요</p>
        <p>Safari가 열리면, 주소창을 길게 터치한 뒤,</p>
        <p>'붙여놓기 및 이동'을 누르면</p>
        <p>정상적으로 이용할 수 있습니다.</p>
        <button
            @click="inappBrowserOut"
            class="safari-button"
        >
          Safari로 열기
        </button>
      </div>
    </div>
  </div>
</template>

<style scoped>
.inapp-redirect-container {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100vw;
  height: 100vh;
  background: white;
  padding: 20px;
  text-align: center;
  font-family: -apple-system, BlinkMacSystemFont, sans-serif;
  z-index: 99999;
  overflow: auto;
}

.inapp-redirect-container h2 {
  padding-top: 48px;
  font-size: 24px;
  font-weight: bold;
}

.redirect-message {
  margin-top: 24px;
  color: #666;
}

.safari-button {
  margin-top: 24px;
  padding: 12px 24px;
  background-color: #007AFF;
  color: white;
  border: none;
  border-radius: 8px;
  font-size: 16px;
  font-weight: bold;
}
</style>